.form {
	width: 100%;
	display: flex;
	flex-direction: column;
	gap: var(--size-5);
	padding: var(--size-5);
	text-wrap: pretty;
	text-align: center;
}

.error {
	color: var(--color-error-text);
}
